import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import StatsBanner, { CTASection } from './components/StatsBanner';
import { featuredVideos, hotVideos } from '@/mocks/videos';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91视频网',
  url: 'https://www.91video.com',
  description: '91视频网是您首选的在线视频平台，汇聚海量高清视频资源，支持多终端流畅播放。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.91video.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91视频网',
  url: 'https://www.91video.com',
  description: '海量高清视频在线观看平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@91video.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="91视频网 - 海量高清视频在线观看平台"
        description="91视频网是您首选的在线视频平台，汇聚海量高清视频资源，支持多终端流畅播放。无论是娱乐、教程还是生活短片，91视频网均可满足您的观看需求，立即免费体验极致视频盛宴。"
        keywords="91视频网,91视频网在线观看,91视频网高清资源,91视频网免费视频,91视频网手机版,91视频网最新视频"
        canonicalUrl="https://www.91video.com"
        schema={{ ...homeSchema, ...orgSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategoryNav />
          <VideoGrid
            title="编辑推荐"
            subtitle="精选优质内容，为你推荐最好看的视频"
            videos={featuredVideos}
            viewAllLink="/category/yule"
          />
          <StatsBanner />
          <VideoGrid
            title="热门视频"
            subtitle="全网最受欢迎的视频内容"
            videos={hotVideos}
            viewAllLink="/category/youxi"
            accentColor="accent"
          />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}